// extracted by mini-css-extract-plugin
module.exports = {"posCenter":"SingpassCallback_posCenter__66kmg","loader":"SingpassCallback_loader__1I_ME","spin":"SingpassCallback_spin__byosX"};